import { formatPhone } from 'utils';
import {
  AgendarCitaState,
  AgendarCitaViews,
  Clinic,
  Patient,
  CitaType,
  Category,
  Doctor,
} from 'utils/interfaces';
import { AgendarCitaInitialState } from './index';
export type Actions =
  | { type: 'reset' }
  | { type: 'setTime'; payload: string }
  | { type: 'setEmail'; payload: string }
  | { type: 'setFormLoading'; payload: boolean }
  | { type: 'setStatusMessage'; payload?: string }
  | { type: 'setView'; payload: AgendarCitaViews }
  | { type: 'setDate'; payload: { date: string } }
  | { type: 'setCrearCitaMessage'; payload?: string }
  | { type: 'setShowConfirmarCita'; payload: boolean }
  | { type: 'setClinic'; payload: { selectedClinic: Clinic } }
  | { type: 'setSchedules'; payload: { schedules: string[] } }
  | { type: 'setPatient'; payload: { patient: Patient; } }
  | { type: 'setCitaType'; payload: { citaType: CitaType } }
  | { type: 'setSelectedCategory'; payload: { selectedCategory: Category } }
  | { type: 'setClinicsList'; payload: { clinics: Clinic[] } }
  | { type: 'setCategoriesList'; payload: { categories: Category[] } }
  | { type: 'setSelectedDoctor'; payload: { selectedDoctor: Doctor } }
  | { type: 'setDoctorsList'; payload: { doctors: Doctor[] } }
  | { type: 'setPhone'; payload: string }
  | { type: 'setCitaId'; payload: string };

export function reducer(
  state: AgendarCitaState,
  action: Actions
): AgendarCitaState {
  switch (action.type) {
    case 'setView': {
      return {
        ...state,
        view: action.payload,
      };
    }
    case 'setPatient': {
      return {
        ...state,
        view: 'selectCita',
        patient: action.payload.patient,
      };
    }
    case 'setFormLoading': {
      return {
        ...state,
        isFormLoading: action.payload,
      };
    }
    case 'setStatusMessage': {
      return {
        ...state,
        statusMessage: action.payload,
      };
    }
    case 'setShowConfirmarCita': {
      return {
        ...state,
        showConfirmarCita: action.payload,
      };
    }
    case 'setClinic': {
      return {
        ...state,
        schedules: [],
        selectedClinic: action.payload.selectedClinic,
      };
    }
    case 'setDate': {
      return {
        ...state,
        isDateTouched: false,
        selectedTime: '',
        selectedDate: action.payload.date,
      };
    }
    case 'setSchedules': {
      return {
        ...state,
        isDateTouched: true,
        schedules: action.payload.schedules,
      };
    }
    case 'setTime': {
      return {
        ...state,
        selectedTime: action.payload.slice(0, 5),
      };
    }
    case 'setCrearCitaMessage': {
      return {
        ...state,
        crearCitaMessage: action.payload,
      };
    }
    case 'setEmail': {
      const copy = { ...state.patient };
      return {
        ...state,
        patient: { ...copy, email: action.payload } as Patient,
      };
    }
    case 'setCitaType': {
      const { citaType } = action.payload;
      return {
        ...state,
        citaType,
        view: 'stepperView'
      };
    }
    case 'setSelectedCategory': {
      return {
        ...state,
        selectedCategory: action.payload.selectedCategory,
      };
    }
    case 'setCategoriesList': {
      return {
        ...state,
        categories: action.payload.categories,
      };
    }
    case 'setClinicsList': {
      return {
        ...state,
        clinics: action.payload.clinics,
      };
    }
    case 'setSelectedDoctor': {
      return {
        ...state,
        selectedDoctor: action.payload.selectedDoctor,
      };
    }
    case 'setDoctorsList': {
      return {
        ...state,
        doctors: action.payload.doctors,
      };
    }
    case 'setPhone': {
      return {
        ...state,
        phone: formatPhone(action.payload),
      };
    }
    case 'setCitaId': {
      return {
        ...state,
        citaId: action.payload,
      };
    }
    case 'reset': {
      return AgendarCitaInitialState;
    }
    default:
      return state;
  }
}
